module.exports = __webpack_public_path__ + "img/home-nav-icon-09.99fe1612.png";